<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-left
      wrap
    >
      <v-flex
              xs12
              md8
      >
        <material-card
          color="green"
          title="Change Password"
        >

          <v-form
                  align="center"
                  v-model="valid" class="mb-4" @keyup.native.enter="valid">
            <v-flex col-md-5>
              <v-text-field
                      label="Old Password"
                      v-model="old_password"
                      type="password"
                      :rules="oldPasswordRules"
                      required
              ></v-text-field>
            </v-flex>
            <v-flex col-md-5>
              <v-text-field
                      label="New Password"
                      v-model="new_password"
                      type="password"
                      :rules="newPasswordRules"
                      required
              ></v-text-field>
            </v-flex>
            <v-flex col-md-5>
              <v-text-field
                      label="Confirm New Password"
                      v-model="confirm_new_password"
                      type="password"
                      :rules="confirmNewPasswordRules"
                      required
              ></v-text-field>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="submit" :disabled="!(old_password && new_password && confirm_new_password && (new_password === confirm_new_password))"
                     color="primary">Change Password</v-btn>
              <!-- <v-btn large @click="onCreateAccount" block color="warning">{{$t('message.createAccount')}}</v-btn> -->
            </v-flex>
            <!-- <p>{{$t('message.bySigningUpYouAgreeTo')}} {{brand}}</p> -->
            <!-- <router-link to="">{{$t('message.termsOfService')}}</router-link> -->
          </v-form>

        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import { changePassword } from '../api/routes';

export default {
  data () {
      return {
          checkbox: false,
          valid: false,
          appLogo: "/img/logo.png",
          token: "",
          old_password: "",
          oldPasswordRules: [v => !!v || "Password is required"],
          new_password: "",
          newPasswordRules: [v => !!v || "New Password is required"],
          confirm_new_password: "",
          confirmNewPasswordRules: [
              v => !!v || "Confirm New Password is required",
              v => this.new_password === this.confirm_new_password || "New Password and Confirm New Password mismatch",],
      };
  },
  mounted() {},
  methods: {
      submit(event) {
          console.log(this.valid);
          if(this.valid) {
              const data = {
                  old_password: this.old_password,
                  new_password: this.new_password,
              };
              changePassword(data)
                  .then(response => {
                      response =response.data;
                      console.log(response);
                      this.$toasted.show(response);
                      // this.old_password = "";
                      // this.new_password = "";
                      // this.confirm_new_password = "";
                  })
                  .catch(err => {
                      console.error(err.response.data);    // ***
                      this.$toasted.show(err.response.data.message)
                  });
          }
      },
  }

}
</script>
